const filter = (value, enumObject) => {
    if (!value || !enumObject) {
        return '--'
    }
    const objeto = Object.values(enumObject).find(item => item.valor === value)
    return objeto ? objeto.texto : '--'
}

export default filter
